import React, { useState } from "react";
import Grid from "@mui/material/Grid2";
import { GRAPH_TYPE } from "../../../constants/trendGraph/trendGraphType";
import { DEFAULT_CUSTOM_CHART_KEY } from "../../../constants/trendGraph/charts";
import { IconButton, Box, useTheme } from "@mui/material";
import { Screenshot } from "../commonComponent/screenshot";
import { CsvDownload } from "../commonComponent/csvDownload";
import { chartSettingList } from "../trendPageCommonFunction";
import { DisplayController } from "./displayController";
import EditIcon from "../icon/editIcon";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const styles = {
  chartTitle: {
    fontSize: "18px",
  },
  chartSubtitleLeft: {
    color: "rgba(255, 255, 255, 0.5)",
  },
  chartSubtitleRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
  },
  maximize: {
    padding: "0 12px !important",
  },
}

export const DisplayGraphHeader = (props) => {
  const {
    vesselId,
    isSepVessel,
    selectedGraph,
    selectedChart,
    selectedChartData,
    selectedEngine,
    setSelectedEngine,
    graphData,
    dataFetchStatus,
    currentVessel,
    setIsCreateCustomCharts,
    screenshotRef,
    graphConfig,
  } = props;
  const { isLoading, isNoData } = dataFetchStatus;
  const { t } = useTranslation();
  const [isDownloading, setIsDownloading] = useState(false);
  const theme = useTheme();
  const isXs = theme.breakpoints.down("sm");
  return (
    <Box component={'div'} sx={{ 
        boxShadow: " 4px 4px 4px 2px rgba(0, 0, 0, 0.1)", 
        padding: "10px", 
        marginRight: isXs ? "0" : "30px",
      }}>
      <Grid container>
        <Grid item size={{xs: 12}} sx={styles.chartTitle}>
          {t(chartSettingList(selectedGraph, isSepVessel)?.find((e) => e.id === selectedChart)?.title)}
        </Grid>
        {selectedGraph === GRAPH_TYPE.CUSTOM && (
          <Grid item size={{xs: 12}} sx={styles.chartSubtitleLeft}>
            {selectedChartData?.otherName}
          </Grid>
        )}
        {selectedChart !== DEFAULT_CUSTOM_CHART_KEY && (
          <>
            <Grid item size={{xs:7}}>
              <DisplayController 
                vesselId={vesselId} 
                currentVessel={currentVessel} 
                selectedEngine={selectedEngine} 
                setSelectedEngine={setSelectedEngine} 
                selectedGraph={selectedGraph} 
              />
            </Grid>
            <Grid item size={{xs: 5}} sx={styles.chartSubtitleRight}>
              {selectedGraph === GRAPH_TYPE.CUSTOM && (
                <IconButton
                  onClick={() => setIsCreateCustomCharts(true)}
                  sx={styles.maximize}
                  size="large">
                  <EditIcon />
                </IconButton>
              )}
              <Screenshot
                isDurationDisabled={isDownloading}
                isNoData={isNoData}
                element={screenshotRef.current}
                vesselName={currentVessel?.name}
                graphType={selectedGraph}
                selectedGraph={selectedGraph === GRAPH_TYPE.CUSTOM ? selectedChartData?.name : selectedChart}
                selectedEngine={selectedEngine}
                isLoading={isLoading}
              />
              <CsvDownload
                vesselId={vesselId}
                graphData={graphData}
                graphType={selectedGraph}
                selectedChart={selectedChart}
                selectedEngines={selectedEngine}
                isDownloading={isDownloading}
                setIsDownloading={setIsDownloading}
                isDurationDisabled={isLoading}
                isNoData={isNoData}
                is1SecFetchEnabled={true}
                isSepVessel={isSepVessel}
                currentVessel={currentVessel}
                graphConfig={graphConfig}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

DisplayGraphHeader.propTypes = {
  vesselId: PropTypes.string,
  isSepVessel: PropTypes.bool,
  selectedGraph: PropTypes.string,
  selectedChart: PropTypes.string,
  selectedChartData: PropTypes.object,
  selectedEngine: PropTypes.string,
  setSelectedEngine: PropTypes.func,
  graphData: PropTypes.array,
  dataFetchStatus: PropTypes.object,
  currentVessel: PropTypes.object,
  setIsCreateCustomCharts: PropTypes.func,
  screenshotRef: PropTypes.object,
  graphConfig: PropTypes.object,
}